import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import MarshallingTypeExclusionCriteriaContMain from "presentation/view/container/Criteria/MarshallingTypeExclusionCriteriaContMain";

CommonEntrypoint(<MarshallingTypeExclusionCriteriaContMain/>)